import React, { useMemo, useState } from 'react';
import * as R from 'ramda';
import { useMedia } from 'use-media';
import { useQuery } from '@apollo/client';
import { GET_VIDEO_SETTINGS } from '@lib/apollo';
import { TaxonomiesFiltersDesktop } from './TaxonomiesFilters.desktop';
import { TaxonomiesFiltersMobile } from './TaxonomiesFilters.mobile';
import { NewTaxonomyItemFieldsFragment } from '@gql/generated';

type Props = {
  taxonomies: NewTaxonomyItemFieldsFragment[];
  selectedTerms: Record<string, string[]>;
  onChange(terms: Record<string, string[]>);
};
const VideosGenresFilters = (props: Props) => {
  const { taxonomies, selectedTerms } = props;
  const { loading } = useQuery(GET_VIDEO_SETTINGS, { ssr: false });
  const [selectedTaxonomySlug, setSelectedTaxonomySlug] = useState(null);
  const isDesktop = useMedia('(min-width: 960px)');

  const handleSelectTaxonomy = (taxonomy) => {
    setSelectedTaxonomySlug(
      selectedTaxonomySlug === taxonomy.slug ? null : taxonomy.slug
    );
  };

  // NOTE: this should probably be lifted up
  // no need to update object here send it to get it back from the parent
  const handleSelectTerm = (term, taxonomy = selectedTaxonomySlug) => {
    // Handle click term here
    const terms = R.clone(selectedTerms);
    if (terms[taxonomy]?.includes(term.slug)) {
      // Unselect term
      terms[taxonomy].splice(terms[taxonomy].indexOf(term.slug), 1);
      if (terms[taxonomy].length === 0) {
        delete terms[taxonomy];
      }
    } else {
      // Select term
      if (terms[taxonomy]) {
        terms[taxonomy].push(term.slug);
      } else {
        terms[taxonomy] = [term.slug];
      }
    }
    props.onChange(terms);
  };

  const clearTaxonomy = (slug) => {
    const terms = R.clone(selectedTerms);
    terms[slug] = [];
    props.onChange(terms);
  };

  const clearAll = () => {
    props.onChange({});
  };

  if (loading) {
    return null;
  }

  return (
    <>
      {isDesktop ? (
        <TaxonomiesFiltersDesktop
          taxonomies={taxonomies}
          selectedTaxonomySlug={selectedTaxonomySlug}
          handleSelectTaxonomy={handleSelectTaxonomy}
          selectedTerms={selectedTerms}
          handleSelectTerm={handleSelectTerm}
          clearAll={clearAll}
          clearTaxonomy={clearTaxonomy}
        />
      ) : (
        <TaxonomiesFiltersMobile
          taxonomies={taxonomies}
          selectedTaxonomySlug={selectedTaxonomySlug}
          selectedTerms={selectedTerms}
          handleSelectTaxonomy={handleSelectTaxonomy}
          handleSelectTerm={handleSelectTerm}
          clearAll={clearAll}
          clearTaxonomy={clearTaxonomy}
        />
      )}
    </>
  );
};

export default VideosGenresFilters;
